module.exports = __webpack_public_path__ + "img/xiaoshan.6555dbf5.png";